var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnsupportedArbitrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.04 24.0418L22.1179 29.3244C22.0362 29.4815 22.0362 29.6448 22.1179 29.8018L25.4784 38.9224L29.3164 36.68L24.6744 24.0418C24.599 23.7214 24.197 23.7214 24.04 24.0418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3736 15.2444C28.2919 14.9241 27.8962 14.9241 27.7329 15.2444L25.8108 20.5271C25.7291 20.6841 25.7291 20.8474 25.8108 21.0045L30.6607 34.3446L31.351 34.8614L33.4208 33.3759L34.5029 32.1129L28.3736 15.2444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2389 3.56281C21.1572 3.48116 21.0819 3.48116 21.0002 3.48116C20.9186 3.48116 20.8369 3.48116 20.7615 3.56281L6.04418 12.0427C5.88715 12.1181 5.80549 12.3631 5.80549 12.5201V29.4799C5.80549 29.7186 5.88715 29.8756 6.04418 29.9573L11.9788 33.3767L11.0974 35.768L4.76278 32.1181C3.80172 31.559 3.24268 30.5226 3.24268 29.4799V12.5201C3.24268 11.402 3.80172 10.441 4.76278 9.88191L19.4801 1.40201C19.9575 1.15704 20.4412 1 21.0002 1H21.0756C21.6346 1 22.1183 1.16332 22.5957 1.40201L37.2377 9.88191C38.1987 10.441 38.7578 11.4774 38.7578 12.5201V29.4799C38.7578 30.598 38.1987 31.559 37.2377 32.1181L22.5203 40.598C22.0429 40.843 21.5593 41 21.0002 41C20.4412 41 19.9575 40.8367 19.4801 40.598L12.809 36.7542L14.7229 34.9578L20.7615 38.4372C20.8432 38.5188 20.9186 38.5188 21.0002 38.5188C21.0819 38.5188 21.1572 38.5188 21.2389 38.4372L35.9562 29.9573C36.1133 29.8819 36.1949 29.6369 36.1949 29.4799V12.5201C36.1949 12.2814 36.1133 12.1244 35.9562 12.0427L21.2389 3.56281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8004 11.3215H16.0378C15.7991 11.3215 15.4788 11.4786 15.3971 11.7235L7.40088 33.6394L11.2388 35.8818L20.0391 11.7989C20.1207 11.5602 19.9574 11.3215 19.7187 11.3215H19.8004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2774 11.3207H22.5148C22.2761 11.3207 21.9557 11.4778 21.8741 11.7227L12.7598 36.6788L16.5977 38.9212L26.516 11.7227C26.5977 11.4841 26.4344 11.2454 26.1957 11.2454L26.2774 11.3207Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsupportedArbitrum);
export default __webpack_public_path__ + "static/media/unsupportedArbitrum.fc8ca9be2e5a5a3be1a5075ddd50ff56.svg";
export { ForwardRef as ReactComponent };